module.exports = __webpack_public_path__ + "img/productBgImg13.79762c62.png";